import React from 'react';
import Introduction from '../components/adn/Intoduction';
import Evolution from '../components/adn/Evolution';

const Adn = () => {
    return (
        <div>
            <Introduction />
            <Evolution />
        </div>
    );
};

export default Adn;
